import React from 'react'
import { FaLock, FaUnlock } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'

type KindDirectionStrictnessControlProps = {
  soft: boolean
  onClick: () => void
}

const KindDirectionStrictnessControl = ({ soft, onClick }: KindDirectionStrictnessControlProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    onClick()
  }

  const label = soft ? 'Soft direction (only restricts the general direction) - click to make strict' : 'Strict direction (edges must follow it exactly) - click to make soft'

  return (
    <div className={cn('control', 'kind-direction-strictness')} data-graph-type="control" title={label}>
      <a className="icon" onClick={handleClick}>
        {soft ? <FaUnlock aria-hidden /> : <FaLock aria-hidden />}
        <span className="sr-only">{label}</span>
      </a>
    </div>
  )
}

export default KindDirectionStrictnessControl
